import { Td, Text } from "@chakra-ui/react";
import { memo } from "react";

interface TableCellProps {
  isDate?: boolean;
  value: string | number;
  colorForValue: string;
  dateColor: string;
  after: {
    [key: string]: string;
  };
  origin: string;
}

const TableCellComponent = ({
  isDate,
  value,
  colorForValue,
  dateColor,
  after,
  origin,
}: TableCellProps) => {
  return (
    <Td
      color="#006699"
      textAlign="center"
      paddingY="5px"
      paddingLeft={isDate ? "5px" : "2px"}
      paddingRight="5px"
      bg={isDate ? dateColor : colorForValue}
      position={isDate ? "sticky" : "relative"}
      left={isDate ? 0 : "auto"}
      zIndex={isDate ? 1 : "auto"}
      _after={after}
      border="none"
      borderBottom="1px solid black"
      borderRight="1px solid black"
      _first={{
        borderLeft: "1px solid black",
      }}
    >
      <Text
        position={!isDate ? "absolute" : "inherit"}
        {...(!isDate && {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%);",
        })}
      >
        {value}
      </Text>
    </Td>
  );
};

export const TableCell = memo(TableCellComponent, (prevProps, nextProps) => {
  return (
    prevProps.value === nextProps.value &&
    prevProps.colorForValue === nextProps.colorForValue &&
    prevProps.dateColor === nextProps.dateColor
  );
});
